export function visitStrategy(x, whatToDo) {
    return whatToDo[x];
}
